import React, { useMemo } from "react";
import Tooltip from "components/Tooltip";
import { IoMdOpen } from "@hacknug/react-icons/io";
import { COLORS } from "utils/styles";
import Analytics, { CLICK_EXTERNAL_LINK } from "utils/analytics";
import { v4 as uuidv4 } from "uuid";
import { useAccountConnectStatusProps } from "utils/selectors";
import StripeOnboardAccountLink from "components/StripeOnboardAccountLink";
import { useLoginWithStripe } from "utils/state";

const DEFAULT_CLASSES = {
  link:
    "link flex flex-row items-center justify-center link__decoration--hover color-primary pointer",
  copy: "f7 pr1 fw5"
};

const DEFAULT_COPY = "View on Stripe";

const StripeExternalLink = ({
  href,
  copy,
  customClasses,
  color = COLORS.blue,
  size = 16,
  tooltip,
  hideCopy = false,
  hideIcon = false,
  hideTooltip = false
}) => {
  const tooltipId = useMemo(() => uuidv4(), []);
  const { authRequired, isDeferredAccount } = useAccountConnectStatusProps();
  const loginWithStripe = useLoginWithStripe();

  if (!href) {
    throw new Error("External link requires destination");
  }
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  let content;

  if (isDeferredAccount) {
    content = (
      <StripeOnboardAccountLink
        copy={copy}
        customClasses={customClasses}
        color={color}
        size={size}
        hideCopy={hideCopy}
        hideIcon={hideIcon}
      />
    );
  } else {
    /**
     * If auth required then prompt to login before deep link into Stripe
     */
    const ctxHref = authRequired ? loginWithStripe : href;

    content = (
      <div
        onClick={() => {
          Analytics.track(CLICK_EXTERNAL_LINK, {
            copy,
            href: ctxHref
          });
        }}
      >
        <a target="_blank" href={ctxHref} className={classes.link}>
          {!hideCopy && (
            <div className={classes.copy}>{copy || DEFAULT_COPY}</div>
          )}
          {!hideIcon && (
            <div className="flex flex-shrink-0">
              <IoMdOpen color={color} size={size} />
            </div>
          )}
        </a>
      </div>
    );
  }

  return !hideTooltip ? (
    <Tooltip id={tooltipId} tooltip={tooltip}>
      {content}
    </Tooltip>
  ) : (
    content
  );
};

export default StripeExternalLink;
